import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;

  & a {
    color: var(--brand-secondary);
  }
`
export const NavItem = styled.a`
  font-size: 12px;
  font-weight: var(--font-regular);
`
export const Item = styled.span`
  font-size: 12px;
  font-weight: var(--font-regular);
`
export const Separator = styled.span`
  margin: 0 4px;
`
